import { Helmet } from 'react-helmet-async';

interface SEOHeadProps {
  title: string;
  description: string;
  path: string;
  keywords?: string;
}

const BASE_URL = 'https://www.bytescan.xyz';

export default function SEOHead({ title, description, path, keywords }: SEOHeadProps) {
  const fullTitle = path === '/'
    ? `ByteScan - ${title}`
    : `${title} - ByteScan | Free Online Tool`;
  const canonicalUrl = `${BASE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="website" />

      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />

      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebApplication',
          name: title,
          description,
          url: canonicalUrl,
          applicationCategory: 'DeveloperApplication',
          operatingSystem: 'Web Browser',
          offers: { '@type': 'Offer', price: '0', priceCurrency: 'USD' },
          isPartOf: {
            '@type': 'WebSite',
            name: 'ByteScan',
            url: BASE_URL,
          },
        })}
      </script>
    </Helmet>
  );
}
